export default __webpack_public_path__ + "static/homepageHero-09a450900b83f383cbacc21e9ccdca14.png";